<template>
  <div class="foot_box" :style="topbgc1">
    <div class="w1200 foo_boxs">
      <div class="foot_right">
        <div class="tip_logo">
          <img :src="footlogo" alt="">
        </div>
        <div class="content">
          <ul>
            <li class="content_li content_li1">
              <a href="javascript:;" class="firsta">彭氏网络平台</a>
              <a href="http://home.pengzushijia.com" target="_blank">平台导航</a>
              <a href="/home">彭祖世家官网门户</a>
              <a href="http://maker.pengzushijia.com" target="_blank">总谱协作编纂平台</a>
              <a href="http://maker.pengzushijia.com/project/allDataBase" target="_blank">彭祖世家根籍总数据库</a>
              <!--<a href="http://admin.pengzushijia.com" target="_blank">综合管理平台</a>-->
              <a href="javascript:void(0)" class="wxhover"><span id="wxhover">彭祖世家微信公众号<svg-icon icon-class="erweima" /></span><img :src="qrcode_wx" alt="" class="wx_peng"></a>
            </li>
            <li class="content_li">
              <a href="javascript:;" class="firsta">彭氏资讯</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9c01a03001f&name=家族要闻" target="_blank">家族要闻</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9c1b5250021&name=宗支动态" target="_blank">宗支动态</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9c113760020&name=活动报道" target="_blank">活动报道</a>
              <a href="/column/?columnId=4028805c6ac3e581016ad88fa01a0006&name=通知公告" target="_blank">通知公告</a>
              <a href="/column?columnId=4028805c6ad91dd4016ad9cc8f670028" target="_blank">家谱总目</a>
            </li>
            <li class="content_li">
              <a href="javascript:;" class="firsta">彭氏文化</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9ca30490027&name=彭祖研究" target="_blank">彭祖研究</a>
              <a href="/column/?columnId=4028805c6ac3e581016ad890821e0008&name=彭氏源流" target="_blank">彭氏源流</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9b139e8001e&name=彭氏名人" target="_blank">彭氏名人</a>
              <a href="/column/?columnId=4028805c6ac3e581016ad886de0a0003&name=彭氏居落" target="_blank">彭氏居落</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9b08983001b&name=彭氏家谱" target="_blank">彭氏家谱</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9b0aa1b001c&name=彭氏宗祠" target="_blank">彭氏宗祠</a>
            </li>
            <li class="content_li">
              <a href="javascript:;" class="firsta">总谱编纂</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9c3adb80022&name=工作动态" target="_blank">工作动态</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9c423c30024&name=各地组织" target="_blank">各地组织</a>
              <a href="/column/?columnId=4028805c6ad91dd4016ad9c3fbe80023&name=经验分享" target="_blank">经验分享</a>
              <a :href="getTokenUrl" target="_blank" @click="changeurl">上传家谱</a>
              <a href="https://easydoc.xyz/#/s/61837885" target="_blank">帮助中心</a>
            </li>
            <li class="content_li content_li_last">
              <a href="javascript:;" class="firsta">总数据库</a>
              <!--<a href="/rootsearch" class="lasta" style="width: 100%;"><span>根籍搜索</span></a>-->
              <a href="/treeList" class="lasta"><span>谱系</span></a><a href="/bookList"><span>谱书</span></a>
              <a href="/booktextList" class="lasta"><span>谱文</span></a><a href="/nodeList"><span>人物</span></a>
              <!--<a href="/bookPageList" class="lasta"><span>书页</span></a><a href="/pictuerList"><span>页图</span></a>-->
              <a href="/news/NEWS" class="lasta"><span>资讯</span></a><a href="/atlas/PHOTO"><span>图集</span></a>
              <a href="/vdo/VIDEO" class="lasta"><span>视频</span></a><a href="/library/DOC"><span>文库</span></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="foot_left">
        <div class="leftcontent">
          <p><span><svg-icon icon-class="enter" /></span><a target="_blank" :href="getTokenUrl" @click="changeurl">进入《彭祖世家总谱·事典》编纂平台</a></p>
          <div class="connect">
            <div class="tip">
              联系我们
            </div>
            <div class="imgbox">
              <span id="wxhover2"><svg-icon icon-class="wx" /></span>
              <img :src="qrcode_wx" alt="" class="wx_peng">
            </div>
            <div class="imgbox">
              <span id="wxhover3"><svg-icon icon-class="wb" /></span>
              <img :src="qrcode_wb" alt="" class="wx_peng3">
            </div>
            <div class="imgbox">
              <span><svg-icon icon-class="qq" /></span>
            </div>
            <div class="foot_phone">
              电话:<span>136 9167 0471</span>
            </div>
            <div class="foot_phone">
              邮箱:<span>Pengzushijia@126.com</span>
            </div>
            <div class="foot_phone">
              网址:<span>www.pengzushijia.com</span>
            </div>
          </div>
        </div>
        <!--<div class="foot_left_img">-->
        <!--<img :src="foot_img" alt="">-->
        <!--</div>-->
      </div>
    </div>
    <div class="foot_map">
      ©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站 Pengzushijia.COM 彭祖世家文化发展有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgba(255, 255, 255, 0.7);">粤ICP备19063974号</a> 技术支持：武汉聚脉网络科技有限公司
    </div>
    <div class="footphone">
      ©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站 Pengzushijia.COM
    </div>
  </div>
</template>
<script>
import { addLoginState } from '@/api/login.js'
export default {
  name: 'Footer',
  data() {
    return {
      getTokenUrl: '',
      topbgc1: {
        backgroundImage: 'url(' + require('@/static/footimgs.png') + ')'
      },
      footlogo: require('@/static/footlogo.png'),
      foot_img: require('@/static/foot_img.png'),
      qrcode_wx: require('@/static/qrcode_wx.png'),
      qrcode_wb: require('@/static/qrcode_wb.png')
    }
  },
  mounted() {
    this.changeurl()
  },
  methods: {
    changeurl(url) {
      url = 'http://maker.pengzushijia.com/ssoLogin/ssoLogin?token='
      // url = 'http://maker.myfamilybook.cn/ssoLogin/ssoLogin?token='
      if (this.getLoca('userid')) {
        addLoginState({ unionid: this.getLoca('unionid') }).then(res => {
          if (res.data.errcode === '0') {
            var nurl = url + res.data.token
            this.getTokenUrl = nurl
          }
          if (res.data.errcode == '1') {
            this.$alert('您的登录信息已经过期，请重新登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/login')
              }
            })
          }
        })
      } else {
        this.getTokenUrl = 'http://maker.pengzushijia.com'
      }
    }
  }

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .footphone{
    display: none;
  }
  .foot_box{
    height: 399px;
    width: 100%;
    position: relative;
    background: no-repeat right top;
    .foo_boxs{
      overflow: hidden;
      background-color:transparent;
      position: relative;
      .foot_right{
        height: 372px;
        width: 750px;
        display: inline-block;
        .tip_logo{
          width: 446px;
          height: 60px;
          font-size: 0;
          display: inline-block;
          overflow: hidden;
          margin-top: 30px;
          img{
            width: 446px;
            height: 60px;
          }
        }
        .content{
          display: inline-block;
          margin-top: 40px;
          overflow: hidden;
          ul{
            display: inline-block;
            overflow: hidden;
            .content_li{
              display: inline-block;
              width: 85px;
              vertical-align: top;
              margin-right: 35px;
              a{
                width: 100%;
                display: inline-block;
                text-align: left;
                color: rgba(255,255,255,.7);
                font-size: 14px;
                padding: 4px 0;
                transition: 0.5s;
                &:hover{
                  color: #ed4040;
                }
              }
              .firsta{
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                margin-bottom: 10px;
                cursor: default;
              }
              .lasta{
                cursor: default;
                span{
                  margin-right: 10px;
                  cursor: pointer;
                  &:hover{
                    color: #ed4040;
                  }
                }
                &:hover{
                  color: #d2cbc5;
                }
              }
            }
            .content_li_last{
              a{
                width: 50%;
              }
              .firsta{
                width: 100%;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                margin-bottom: 10px;
                cursor: default;
              }
            }
            .content_li1{
              width: 175px;
              margin-left: 25px;
            }
          }
        }
      }
      .foot_left{
        width: 283px;
        display: inline-block;
        height: 372px;
        vertical-align: top;
        position: absolute;
        right: 0;
        top: 0;
        .leftcontent{
          display: inline-block;
          overflow: hidden;
          margin-top: 50px;
          p{
            padding: 8px 5px;
            background-color: #503f2f;
            span{
              color: #ba994c;
              svg{
                font-size: 22px;
              }
            }
            a{
              display: inline-block;
              color: #ba994c;
              font-size: 14px;
              padding-bottom: 1px;
              border-bottom: 1px solid #ba994c;
              vertical-align: top;
              margin-left: 10px;
            }
          }
        }
        .connect{
          .tip{
            color:rgba(255,255,255,.9);
            margin-top: 45px;
            margin-bottom: 25px;
            font-size: 16px;
          }
          .imgbox{
            display: inline-block;
            width: 44px;
            height: 44px;
            border: 1px solid #c3b9b1;
            line-height: 44px;
            text-align: center;
            margin-right: 20px;
            margin-bottom: 10px;
            position: relative;
            span{
              color: #c3b9b1;
              height: 44px;
              display: inline-block;
              line-height: 44px;
              padding-top: 5px;
              svg{
                font-size: 25px;
              }
            }
            img{
              position: absolute;
              width: 100px;
              bottom: 0;
              left: 50px;
              height: 0;
              transition: 0.2s;
              z-index: 3;
            }
          }
          .foot_phone{
            color:rgba(255,255,255,.7);
            margin-top: 5px;
            font-size: 14px;
            span{
              color: #e1dcd8;
              font-size: 13px;
            }
          }
        }
        .foot_left_img{
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 0;
          overflow: hidden;
          img{
            width: 322px;
            height: 400px;
          }
        }
      }
    }
  }
  .wxhover{
    position: relative;
    img{
      position: absolute;
      width: 100px;
      bottom: 0;
      left: 160px;
      height: 0;
      transition: 0.2s;
    }
    #wxhover:hover + .wx_peng{
      height: 100px;
    }
  }
  #wxhover2:hover + .wx_peng{
    height: 100px;
  }
  .imgbox .wx_peng3{
    position: absolute;
    width: 100px;
    bottom: 0;
    left: 150px;
    height: 0;
    transition: 0.2s;
    z-index: 3;
  }
  #wxhover3:hover + .wx_peng3{
    height: 100px;
  }
  .foot_map{
    text-align: center;
    font-size: 14px;
    color: rgba(255,255,255,.4);
    padding-top: 20px;
    background: #69513c;
    width: 100%;
    padding-bottom:20px;
  }
  .wxhover{
    svg{
      color: #be9d4e;
    }
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .foot_box{
      height: auto;
      .foo_boxs .foot_right{
        display: none;
      }
    }
    .foot_map{
     display: none;
    }
    .footphone{
      display: block;
      text-align: center;
      background-color: #7E6B5A;
      color: #ffffff;
      font-size: 12px;
      padding: 5px 0;
    }
  }
</style>
